import { render, staticRenderFns } from "./ChildAssessmentVue.vue?vue&type=template&id=b8be3894&scoped=true&"
import script from "./ChildAssessmentVue.vue?vue&type=script&lang=js&"
export * from "./ChildAssessmentVue.vue?vue&type=script&lang=js&"
import style0 from "./ChildAssessmentVue.vue?vue&type=style&index=0&id=b8be3894&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8be3894",
  null
  
)

export default component.exports